/* eslint-disable indent */
/* eslint-disable no-unused-vars */

import React from "react";
import { Form } from "antd";
import BaseCreditBooking from "./BaseCreditBooking";

const ClientCreditBooking = (props) => {
  return <BaseCreditBooking {...props} isClientAdmin={true} />;
};

export default ClientCreditBooking;
